module.exports = __webpack_public_path__ + "images/bg-img-start-mobile_e458234c513082871c4258f5ab53f730.png";